module.exports = __webpack_public_path__ + "media/images/back_arrow-64520f5a3e8ddf1a63b34a616a96a809.png";